module.exports = __webpack_public_path__ + "img/3.69e9c1b1.jpg";